export default __webpack_public_path__ + "static/media/5-light.caa3ca67.png";